import { render, staticRenderFns } from "./PaginationClient.vue?vue&type=template&id=064ab8de&"
import script from "./PaginationClient.vue?vue&type=script&lang=js&"
export * from "./PaginationClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports